import { RouteConfig } from 'vue-router';

import { TableName } from '@/enums/tableName.enum';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import Presences from '@/views/team/tabs/Presences.vue';

export const teamPresencesRoute: RouteConfig = {
  path: 'presences',
  name: 'teamPresences',
  component: Presences,
  meta: { title: 'titles.team.presences' },
  beforeEnter: (to: any, from: any, next: any) => {
    store.commit('presences/setEntityType', TableName.Team);
    store.commit('presences/setEntityId', to.params.teamId.toString());

    store
      .dispatch('team/player/list', { teamId: tryParseInt(to.params.teamId) })
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: 'messages.team.player.listError' }));
  }
};
